import React, { useEffect, useRef, useState } from "react";
import "../Style/Galeryhero.css";
import { useLanguage } from "../Context/Languagecontext";

const GalleryHero = () => {
  const heroRef = useRef(null);
  const { t, lang } = useLanguage();


  const heroCopy = t?.galleryHero || {};

  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          el.classList.add("in-view");
        }
      },
      {
        threshold: 0.15,
        rootMargin: "0px 0px -10% 0px",
      }
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  const titleData = heroCopy?.title || {};
  const row1 = titleData?.row1 || {};
  const row2 = titleData?.row2 || {};
  const statsList = heroCopy?.stats || [];

  return (
    <section
  ref={heroRef}
  className={`Gallery-hero${lang === 'ta' ? ' Gallery-hero--tamil' : ''} ${isInView ? 'in-view' : ''}`}
>
      {/* Background layers */}
      <div className="gh-bg-layer gh-bg-vignette" />
      <div className="gh-bg-layer gh-bg-grain" />
      <div className="gh-bg-layer gh-bg-radial" />

      {/* Corner ornaments */}
      <svg className="gh-ornament gh-ornament--tl" viewBox="0 0 120 120">
        <path d="M10 110 Q10 10 110 10" stroke="var(--clr-gold)" strokeWidth="0.8" fill="none" opacity="0.5" />
        <circle cx="10" cy="10" r="3" fill="var(--clr-gold)" opacity="0.6" />
      </svg>

      <svg className="gh-ornament gh-ornament--tr" viewBox="0 0 120 120">
        <path d="M110 110 Q110 10 10 10" stroke="var(--clr-gold)" strokeWidth="0.8" fill="none" opacity="0.5" />
        <circle cx="110" cy="10" r="3" fill="var(--clr-gold)" opacity="0.6" />
      </svg>

      {/* Particles */}
      {Array.from({ length: 12 }).map((_, i) => (
        <span key={i} className={`gh-particle gh-particle--${i + 1}`} />
      ))}

      {/* Content */}
      <div className="gh-content">
        {/* Eyebrow */}
        <div className="gh-eyebrow">
          <span className="gh-eyebrow__line" />
          <span className="gh-eyebrow__text">
            {heroCopy?.eyebrow || ""}
          </span>
          <span className="gh-eyebrow__line" />
        </div>

        {/* Title */}
        <h1 className="gh-title">
          <span className="gh-title__row">
            <span className="gh-word gh-word--1">{row1.word1 || ""}</span>
            <span className="gh-word gh-word--2">{row1.word2 || ""}</span>
            <span className="gh-word gh-word--serif gh-word--3">{row1.word3 || ""}</span>
          </span>

          <span className="gh-title__row">
            <span className="gh-word gh-word--4">{row2.word4 || ""}</span>
            <span className="gh-word gh-word--5">{row2.word5 || ""}</span>
            <span className="gh-word gh-word--serif gh-word--6">{row2.word6 || ""}</span>
          </span>
        </h1>

        {/* Subtitle */}
        <p className="gh-subtitle">
          {heroCopy?.subtitle || ""}
        </p>

        {/* Stats */}
        <div className="gh-stats">
          {statsList.length > 0 &&
            statsList.map((item, i) => (
              <React.Fragment key={i}>
                {i > 0 && <span className="gh-stat-divider" />}
                <div
                  className="gh-stat"
                  style={{ "--stat-delay": `${1 + i * 0.15}s` }}
                >
                  <span className="gh-stat__num">{item?.num || ""}</span>
                  <span className="gh-stat__label">{item?.label || ""}</span>
                </div>
              </React.Fragment>
            ))}
        </div>
      </div>

      {/* Wave */}
      <div className="gh-wave-wrap">
        <svg className="gh-wave" viewBox="0 0 1440 110" preserveAspectRatio="none">
          <path d="M0,60 C240,110 480,10 720,55 C960,100 1200,20 1440,60 L1440,110 L0,110 Z" fill="rgba(54,4,5,0.18)" />
          <path d="M0,65 C240,115 480,15 720,60 C960,105 1200,25 1440,65 L1440,110 L0,110 Z" fill="var(--clr-ivory)" />
        </svg>
      </div>
    </section>
  );
};

export default GalleryHero;